module.exports = __webpack_public_path__ + "static/media/0174_Small.ad43ae69.jpg";